import { Component } from '@angular/core';

@Component({
    selector: 'app-assertion-gen-app-layout',
    templateUrl: './assertion-gen-app-layout.component.html',
    styleUrl: './assertion-gen-app-layout.component.css',
    standalone: false
})
export class AssertionGenAppLayoutComponent {

}
